export function ArticlePage({ children }) {
  return (
    <div className="root">
      {children}
      <style jsx>{`
        .root {
          color: var(--bgBlueish__text);
        }

        .root > :global(p) {
          font-size: 18px;
          line-height: 1.5;
        }

        @media screen and (min-width: 750px) {
          .root {
            max-width: 620px;
            margin: 0 auto;
          }
        }
      `}</style>
    </div>
  );
}
